import { atomWithRefresh } from "../utils";
import { AllPlansType, ChatbotsPlanName } from "../types";

export interface ChatbotUsageSuccessResponse {
  chatbots: {
    count: number;
    limit: number | null; // null means unlimited
  };
  plan: {
    name: ChatbotsPlanName;
    type: AllPlansType;
  };
  needsToUpgrade: boolean;
}

export const chatbotUsageAtom_SUSPENDS = atomWithRefresh<
  Promise<ChatbotUsageSuccessResponse | null>
>(async () => {
  try {
    const response = await fetch(`/api/canvasui/chatbots/usage`);

    if (!response.ok) {
      return null;
    }

    const responseData: ChatbotUsageSuccessResponse = await response.json();
    return responseData;
  } catch {
    return null;
  }
});

chatbotUsageAtom_SUSPENDS.debugLabel = "chatbotUsageAtom_SUSPENDS";
